import {Eye} from "react-feather";
import {Form} from "pages/Payments/lib";
import {togglePanel} from "global/slices";
import {useTheme} from "styled-components";
import {useNavigate} from "react-router-dom";
import {PaymentOutlined} from "@mui/icons-material";
import {useAppDispatch, useAppSelector} from "hooks";
import {IconButton, Row, Typography} from "components";
import {TableRow, TableCell, TableBody} from "@mui/material";

interface BodyProps {}

export const Body: React.FC<BodyProps> = () => {
  const push = useNavigate();
  const dispatch = useAppDispatch();
  const {blackWhite, black} = useTheme();
  const {credits} = useAppSelector("credits");

  return (
    <TableBody>
      {credits.map((credit, key) => {
        const {
          id,
          codigo,
          nombre,
          cedula,
          correo,
          estatus,
          cliente,
          apellido,
          telefono,
        } = credit;

        return (
          <TableRow hover key={`${id}-${key}`} tabIndex={-1}>
            <TableCell padding="none">
              <Typography>{codigo}</Typography>
            </TableCell>
            <TableCell>
              <Typography>
                {nombre} {apellido}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography>{cedula}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{correo}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{telefono}</Typography>
            </TableCell>
            <TableCell>
              <Typography color={black}>{estatus?.toUpperCase()}</Typography>
            </TableCell>
            <TableCell align="right">
              <Row justifyContent="flex-end">
                {credit["finanzas"] && (
                  <IconButton
                    toolTip="Reportar pago"
                    icon={<PaymentOutlined style={{color: blackWhite}} />}
                    onClick={() => {
                      dispatch(
                        togglePanel({
                          type: "open",
                          width: "500px",
                          title: `Reportar pago a ${nombre}`,
                          component: <Form credit={credit} />,
                        }),
                      );
                    }}
                  />
                )}
                <IconButton
                  toolTip="Ver detalles"
                  icon={<Eye color={blackWhite} />}
                  onClick={() => {
                    push(`/clients/${cliente.id}`);
                  }}
                />
              </Row>
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
};
